import SimpleButton from 'ui/Element/Button'
import { PlatformEvent } from 'lib/util'

/**
 * Intended to display a button.
 *
 * @param {Object} props
 * @returns {JSX.Element}
 */
export const ListItemCellButton = ({ value, labels, events }) => (
  <SimpleButton
    events={{ onClick: (event) => {
      events.onSecondaryAction(new PlatformEvent(event, value))
    } }}
    value={labels.button}
  />
)

export default ListItemCellButton
